var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCashDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cash-dollar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m.8-12a.8.8 0 1 0-1.6 0v.136A2.4 2.4 0 0 0 5.6 6.4c0 .81.288 1.416.82 1.815.432.324.972.458 1.333.548l.053.013c.44.11.668.18.814.289.068.05.18.146.18.535a.8.8 0 0 1-.787.8l-.037-.005a1.3 1.3 0 0 1-.223-.054 2 2 0 0 1-.787-.507.8.8 0 0 0-1.132 1.132c.479.478.97.738 1.366.877V12a.8.8 0 0 0 1.6 0v-.136A2.4 2.4 0 0 0 10.4 9.6c0-.81-.288-1.416-.82-1.815-.432-.324-.972-.458-1.333-.548l-.053-.013c-.44-.11-.668-.18-.814-.289-.068-.05-.18-.146-.18-.535a.8.8 0 0 1 .787-.8l.037.004c.046.007.124.022.223.055.196.065.485.204.787.507a.8.8 0 0 0 1.132-1.132A3.6 3.6 0 0 0 8.8 4.157z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cash-dollar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgCashDollar;